export default "__VITE_ASSET__Cu02iW_I__"